import styled from "styled-components/macro";

const Scrollable = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto;
`;

export default Scrollable;
